
import React from 'react';
import {ReactComponent as ErrorIcon} from '../../assets/images/empty/pictorial_icons_set.svg';
import { regular } from '@fortawesome/fontawesome-svg-core/import.macro';
import CustomButtonLoader from '../global/CustomButtonLoader.component';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hasError: false,
            error: null,
        };
    }
    static getDerivedStateFromError(error) {
        return {hasError: true, error};
    }
    componentDidCatch(error, errorInfo) {
        console.error("Error caught by Error boundary:", error, errorInfo);
    }
    handleRefresh = () => {
        window.location.reload();
    };
    render() {
        if(this.state.hasError) {
            return(
                <div className='w-100 d-flex align-items-center justify-content-center text-center bg-blue-gray-50' style={{ height: "100vh" }}>
                    <div>
                        <ErrorIcon className='mb-3' />
                        <p className='mb-1 text-blue-700 fw-semibold'>Something went unexpectedly.</p>
                        <p className='mb-3 text-blue-gray-500 cm-sm-txt fw-medium'>This is not something we expected or intended. Please connect with our support team to solve this issue.</p>
                        <CustomButtonLoader
                            colorTheme={"blue"}
                            icon={regular("refresh")}
                            reverseIconDirection={false}
                            buttonLabel={"Reload Page"}
                            buttonStyle={"px-3 py-2 mx-auto mt-3 cm-mar-left-icon"}
                            handleOnClick={this.handleRefresh}
                        />
                    </div>
                </div>
            )
        }
        return this.props.children;
    }
}
export default ErrorBoundary;
